import * as xd from 'extendom';
import {ReplyPage} from './reply';

type data = ReplyPage;
type content0 = xd.ContentType<() => data>;
type scope0 = undefined;

// @ts-ignore
function create1(this: content0, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['div']): boolean {
    return this.mode == 'preview';
}
xd.FUNCTIONS['this.mode == \'preview\''] = create1;

// @ts-ignore
function content1(this: content0, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['div']) {
    return this.reply;
}
xd.FUNCTIONS['this.reply'] = content1;
type content1 = xd.ContentType<typeof content1>;
(value: any): content1 => value;

// @ts-ignore
function content2(this: content1, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['div']) {
    return this.body;
}
xd.FUNCTIONS['this.body'] = content2;
type content2 = xd.ContentType<typeof content2>;
(value: any): content2 => value;

// @ts-ignore
function content3(this: content1, data: data, scope: scope0, error: unknown, element:
    undefined) {
    return this.uploader;
}
xd.FUNCTIONS['this.uploader'] = content3;
type content3 = xd.ContentType<typeof content3>;
(value: any): content3 => value;

// @ts-ignore
function content4(this: content3, data: data, scope: scope0, error: unknown, element:
    undefined) {
    return this.attachments;
}
xd.FUNCTIONS['this.attachments'] = content4;
type content4 = xd.ContentType<typeof content4>;
(value: any): content4 => value;

// @ts-ignore
function create2(this: content4, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['div']): boolean {
    return this.alive;
}
xd.FUNCTIONS['this.alive'] = create2;

// @ts-ignore
function attribute1(this: content4, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['a']) {
    return {href: this.href, onclick: this.onClickView};
}
xd.FUNCTIONS['{href: this.href, onclick: this.onClickView}'] = attribute1;
(value: ReturnType<typeof attribute1>): xd.AttributeType<
    ReturnType<typeof attribute1>, data, scope0, HTMLElementTagNameMap['a'], false> => value;

// @ts-ignore
function text1(this: content4, data: data, scope: scope0, error: unknown, element:
    undefined) {
    return String.raw`${this.filename}`;
}
xd.FUNCTIONS['String.raw`${this.filename}`'] = text1;

// @ts-ignore
function attribute2(this: content0, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['form']) {
    return this.formListeners();
}
xd.FUNCTIONS['this.formListeners()'] = attribute2;
(value: ReturnType<typeof attribute2>): xd.AttributeType<
    ReturnType<typeof attribute2>, data, scope0, HTMLElementTagNameMap['form'], false> => value;

// @ts-ignore
function initial1(this: content0, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['form']) {
    return this.initiateForm(element);
}
xd.FUNCTIONS['this.initiateForm(element)'] = initial1;

// @ts-ignore
function create3(this: content0, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['div']): boolean {
    return data.mode == 'input';
}
xd.FUNCTIONS['data.mode == \'input\''] = create3;

// @ts-ignore
function attribute3(this: content1, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['textarea']) {
    return {onchange: this.onChangeBody};
}
xd.FUNCTIONS['{onchange: this.onChangeBody}'] = attribute3;
(value: ReturnType<typeof attribute3>): xd.AttributeType<
    ReturnType<typeof attribute3>, data, scope0, HTMLElementTagNameMap['textarea'], false> => value;

// @ts-ignore
function property1(this: content1, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['textarea']): xd.ElementWritableProperties<HTMLElementTagNameMap['textarea']> {
    return {value: this.body};
}
xd.FUNCTIONS['{value: this.body}'] = property1;

// @ts-ignore
function content5(this: content1, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['div']) {
    return this.uploader;
}
xd.FUNCTIONS['this.uploader'] = content5;
type content5 = xd.ContentType<typeof content5>;
(value: any): content5 => value;

// @ts-ignore
function scope1(this: content5, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['div']) {
    return this;
}
xd.FUNCTIONS['this'] = scope1;
type scope1 = ReturnType<typeof scope1>;

// @ts-ignore
function content6(this: content5, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['div']) {
    return this.attachments;
}
xd.FUNCTIONS['this.attachments'] = content6;
type content6 = xd.ContentType<typeof content6>;
(value: any): content6 => value;

// @ts-ignore
function create4(this: content6, data: data, scope: scope1, error: unknown, element:
    HTMLElementTagNameMap['div']): boolean {
    return this.alive;
}
xd.FUNCTIONS['this.alive'] = create4;

// @ts-ignore
function attribute4(this: content6, data: data, scope: scope1, error: unknown, element:
    HTMLElementTagNameMap['a']) {
    return {href: this.href, onclick: this.onClickView};
}
xd.FUNCTIONS['{href: this.href, onclick: this.onClickView}'] = attribute4;
(value: ReturnType<typeof attribute4>): xd.AttributeType<
    ReturnType<typeof attribute4>, data, scope1, HTMLElementTagNameMap['a'], false> => value;

// @ts-ignore
function text2(this: content6, data: data, scope: scope1, error: unknown, element:
    undefined) {
    return String.raw` ${' '} `;
}
xd.FUNCTIONS['String.raw` ${\' \'} `'] = text2;

// @ts-ignore
function attribute5(this: content6, data: data, scope: scope1, error: unknown, element:
    HTMLElementTagNameMap['button']) {
    return {onclick: this.onClickDelete};
}
xd.FUNCTIONS['{onclick: this.onClickDelete}'] = attribute5;
(value: ReturnType<typeof attribute5>): xd.AttributeType<
    ReturnType<typeof attribute5>, data, scope1, HTMLElementTagNameMap['button'], false> => value;

// @ts-ignore
function text3(this: content6, data: data, scope: scope1, error: unknown, element:
    undefined) {
    return String.raw` ${this.filename} `;
}
xd.FUNCTIONS['String.raw` ${this.filename} `'] = text3;

// @ts-ignore
function attribute6(this: content5, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['input']) {
    return {onchange: this.onChangeFile};
}
xd.FUNCTIONS['{onchange: this.onChangeFile}'] = attribute6;
(value: ReturnType<typeof attribute6>): xd.AttributeType<
    ReturnType<typeof attribute6>, data, scope0, HTMLElementTagNameMap['input'], false> => value;

// @ts-ignore
function attribute7(this: content0, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['button']) {
    return {onclick: this.onClickPreview};
}
xd.FUNCTIONS['{onclick: this.onClickPreview}'] = attribute7;
(value: ReturnType<typeof attribute7>): xd.AttributeType<
    ReturnType<typeof attribute7>, data, scope0, HTMLElementTagNameMap['button'], false> => value;

// @ts-ignore
function create5(this: content0, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['div']): boolean {
    return data.mode == 'preview';
}
xd.FUNCTIONS['data.mode == \'preview\''] = create5;

// @ts-ignore
function attribute8(this: content0, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['button']) {
    return {onclick: this.onClickBack};
}
xd.FUNCTIONS['{onclick: this.onClickBack}'] = attribute8;
(value: ReturnType<typeof attribute8>): xd.AttributeType<
    ReturnType<typeof attribute8>, data, scope0, HTMLElementTagNameMap['button'], false> => value;

// @ts-ignore
function attribute9(this: content0, data: data, scope: scope0, error: unknown, element:
    HTMLElementTagNameMap['button']) {
    return {onclick: this.onClickSubmit};
}
xd.FUNCTIONS['{onclick: this.onClickSubmit}'] = attribute9;
(value: ReturnType<typeof attribute9>): xd.AttributeType<
    ReturnType<typeof attribute9>, data, scope0, HTMLElementTagNameMap['button'], false> => value;
